import React, { useEffect, useState } from 'react'
import { message, Button, Col, Row,} from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'
import '../course.module.css'
import * as constants from '../../../constants/constants'
import kejianEmpty from '../../../static/image/empty/queshengye-kejian.png'

import slidesStyles from './course-main-teacher-slides.module.less'
import Cookies from 'js-cookie'
import courseTeacherMenuStyles from "../menu/course-main-teacher-menu.module.less";
import { LockOutlined } from '@ant-design/icons';


import Icon from '@ant-design/icons'


import  {ReactComponent as filepdfSvg }   from '../../../static/image/course/pdf.svg'
import { ReactComponent as filepptSvg }   from '../../../static/image/course/ppt.svg'
import { ReactComponent as filewordSvg }   from '../../../static/image/course/word.svg'
import { ReactComponent as fileexcelSvg }   from '../../../static/image/course/excel.svg'
import { ReactComponent as filecsvSvg }   from '../../../static/image/course/csv.svg'
import { ReactComponent as fileotherSvg }   from '../../../static/image/course/otherfile.svg'

import  {ReactComponent as downloadSvg }   from '../../../static/image/course/download.svg'
const downloadIcon = (props:any) => (<Icon component={downloadSvg} {...props} />)


const filepdfIcon = (props:any) => (<Icon component={filepdfSvg} {...props} />)
const filepptIcon = (props:any) => (<Icon component={filepptSvg} {...props} />)
const filewordIcon = (props:any) => (<Icon component={filewordSvg} {...props} />)
const fileexcelIcon = (props:any) => (<Icon component={fileexcelSvg} {...props} />)
const filecsvIcon = (props:any) => (<Icon component={filecsvSvg} {...props} />)
const fileotherIcon = (props:any) => (<Icon component={fileotherSvg} {...props} />)



export interface Props {
  course_id: any,                
  is_pay: any,
  is_overdue: any
}
/** 平台课程列表页*/
export const PlatformCourseSlides: React.FC<Props> = (props) => {
  const { course_id, is_pay, is_overdue} = props
  const [slides, setSlides] = useState([] as any[]) //课程的课件

  const querySlides = () => {
    sendHttpPostRequest(
      'course/api/user_query_platform_course_slides',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
        } else if (response.is_ok) {
          setSlides(response.lecture_list)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 点击下载
  const onDownloadSlidesClick = (url: any, event: any) => {
    event.preventDefault()
    window.open(url?.startsWith('http') ? url : constants.BACKEND_URL + url)
  }


  // 渲染操作
  const renderActions = (text: any, record: any) => {
    return (
      <div>
          { is_overdue == false && is_pay == true ? <Button
            onClick={onDownloadSlidesClick.bind(this, record.url)}
            className={slidesStyles.actionBtn}
            style={{ borderRadius: 20, marginRight: 5 }}
            size="small"
            type="link"
          >
            {' '}
            下载{' '}
          </Button> :<LockOutlined  className={courseTeacherMenuStyles.iconbuttons}/>  }
      </div>
    )
  }
  const slidesCols: any = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 80,
      render: (text, record, index) => slides.indexOf(record) + 1,
    },
    {
      title: '课件',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: 'auto',
      render: (text: any, record: any) => {
        return <div className={slidesStyles.slideName}> {text} </div>
      },
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 120,
      ellipsis: true,
      align: 'center',
      render: renderActions,
    },
  ]


    const getBackgroundByFileName = (filename:any)=> {
    let suffix = filename.toLowerCase()
    if (suffix.endsWith("ppt") || suffix.endsWith("pptx") ) {
        return "#f57c001a"
    }else if (suffix.endsWith("pdf")){
        return "#d32f2f1a"
    }else if (suffix.endsWith("xls") || suffix.endsWith("xlsx")) {
        return "#388e3c1a"
    }else if (suffix.endsWith("doc") || suffix.endsWith("docx")) {
        return "#1976d21a"
    }else if (suffix.endsWith("csv")) {
        return "#00796b1a"
    }else {
        return "#37474f1a"
    }
      
  }

  const getIconByFileName = (filename:any)=> {
    let suffix = filename.toLowerCase()
    if (suffix.endsWith("ppt") || suffix.endsWith("pptx") ) {
        return filepptIcon
    }else if (suffix.endsWith("pdf")){
        return filepdfIcon
    }else if (suffix.endsWith("xls") || suffix.endsWith("xlsx")) {
        return fileexcelIcon
    }else if (suffix.endsWith("doc") || suffix.endsWith("docx")) {
        return filewordIcon
    }else if (suffix.endsWith("csv")) {
        return filecsvIcon
    }else {
        return fileotherIcon
    }
      
  }

  useEffect(() => {
    querySlides()
  }, [])

  return (
    <div >
      <Row align={"middle"} gutter={[24,24]}>
        {
          slides?.map((slide, slideIndex)=>(
            <Col span={8} key={slideIndex}>
              <div className={slidesStyles.slideCard}>
                  <Row wrap={false} align="middle" style={{padding: 16}}>
                    <Col flex="60px">
                      <div>
                        <span className={slidesStyles.fileIconWrapper} style={{background:getBackgroundByFileName(slide?.name)}}>
                          <Icon component={getIconByFileName(slide?.name)}/>
                        </span>

                      </div>
                    </Col>

                    <Col flex="auto">
                      <div className={slidesStyles.slideName}>
                        {slide?.name}
                      </div>
                    </Col>
                  </Row>

                  <Row wrap={false} align="middle" className={slidesStyles.actionDiv}>
                    <Col span={12} style={{textAlign:'left'}}>

                    </Col>
                    <Col span={12} style={{textAlign:'right'}}>
                      <div>

                         { is_overdue == false && is_pay == true ?  <span title="下载" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onDownloadSlidesClick.bind(this, slide?.url)}
                           
                          ><Icon component={downloadIcon}/></span>  :<LockOutlined  className={courseTeacherMenuStyles.iconbuttons}/>  }
                          
                          

                        
                      </div>
                    </Col>
                  </Row>

              </div>
            </Col>
          ))
        }



      </Row>

        {slides.length == 0 && (
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={kejianEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
              本课程还没添加课件~
            </div>
          </div>
        )}

    </div>
  )
}

export default PlatformCourseSlides
